import React from 'react';
import {RecordFieldChangeStore,RenderUpdateModifiedTagStore,RecordDataMethodFieldChangedStore} from '../../stores/RecordsStore';
import {BindStyleStore,CmdUpdateShowDecimalStore} from '../../stores/CmdTypeStore';
import FormItemUtil from '../../utils/FormItemUtil';
import StringUtil from '../../utils/StringUtil';
export default class FormItemEditorRender extends React.Component
{
	constructor(props) {
		super(props);
		this.state = {recordValue:props.value};
		this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
		this.unsubscribeRecordDataMethodFieldChangedStore = RecordDataMethodFieldChangedStore.listen(this.onRecordDataMethodChanged.bind(this));
		if(!this.props.forLookup)
			this.unsubscribeRenderUpdateModifiedTagStore = RenderUpdateModifiedTagStore.listen(this.onRenderUpdateModifiedTag.bind(this));
		this.unsbuscribeBindStyleStore = BindStyleStore.listen(this.onBindStyleStore.bind(this));

	}


	componentWillUnmount()
	{
		this.unsubscribeRecordFieldChangeStore();
		this.unsubscribeRecordDataMethodFieldChangedStore();
		if(!this.props.forLookup)
			this.unsubscribeRenderUpdateModifiedTagStore();
		this.unsbuscribeBindStyleStore();
	}

	componentDidMount()
	{
		let copy = Object.assign({},this.props.contextMenuData);
		if(copy.items)
		{
			for(let i = 0;i<copy.items.length;i++)
			{
				let item = copy.items[i];
				if(item && item.label == "过滤[Ctrl+T]")
				{
					item.action = this.queryFilter.bind(this);
					break;
				}
			}
			$(this.componentLabel).contextPopup(copy);
		}
		else
		{
			$(this.componentLabel).contextPopup(this.props.contextMenuData);
		}
	}

	queryFilter()
	{
		if(!this.props.group)
			return;
		var _dataField = this.props.dataField;
		if(_dataField && this.props.rowData && this.props.rowData.hasOwnProperty(_dataField))
		{
			
			var value = this.props.rowData[_dataField];
			this.props.group.queryFilter(_dataField,value,true);
		}
	}

	/*componentDidUpdate()
	{
		let gridCellDrag = window.gridCellDrag;
		if(gridCellDrag)
		{
			//= {fromRow:fromRow,toRow:toRow,cellKey:cellKey,rows:rows};
			if(this.props.dataField == gridCellDrag.cellKey && this.props.gridXml.id == gridCellDrag.gridId)
			{
				let _index = this.props.group.records.indexOf(this.props.rowData);
				if(_index>gridCellDrag.fromRow && _index<=gridCellDrag.toRow)
					$(this.componentLabel).addClass("gridCellMutiSelected");
			}
		} 
	}*/

	componentWillReceiveProps(nextProps)
	{
		if(nextProps.rowData != this.props.rowData)
		{
			this.origRecord = Object.assign({},nextProps.rowData);
		}
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(record == this.props.rowData)
		{
			//alert(this.props.dataField + "   " + dataField);
			if(this.props.dataField == dataField)
			{

				//此处只更新UI 没有遵循react只关注当前状态的组件封装思想 但是等到下次失效时 由于数据已发生更改 所以这个逻辑没有问题
				/*$(this.componentLabel).html(this.getDisplay(newValue));
				this.updateModifiedTag();*/
				this.setState({recordValue:newValue});
			}
		}
	}

	onRecordDataMethodChanged(record,dataField)
	{
		if(record == this.props.rowData)
		{
			if(this.props.dataField == dataField)
			{			
				this.setState({recordValue:this.props.rowData[dataField]});
			}
		}
	}

	updateModifiedTag()
	{
		let newValue = this.props.rowData[this.props.dataField];
		var origValue = this.origRecord[this.props.dataField];
		if(origValue != newValue)
		{
			//alert(origValue + "  " + newValue);
			this.currentDataFieldChanged = true;
			$(this.modifiedTag).css("display","block");
		}
		else
		{
			this.currentDataFieldChanged = false;
			$(this.modifiedTag).css("display","none");
		}
	}

	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;
		return _value;
	}

	onRenderUpdateModifiedTag(groupAlias,currentRecord)
	{
		if(this.props.group && this.props.group.groupAlias == groupAlias)
		{
			let key = groupAlias+".recId";
			if(this.props.rowData[key] == currentRecord[key])
				this.forceUpdate();
		}
	}

	getRowStyles()
	{
		let menuItemId = this.props.menuItemId;
		let formId = this.props.formId;
		let gridId = this.props.gridXml.id;
		return FormItemUtil.getControlStyles(menuItemId,formId,gridId);
	}

	getClientLayerRowStyles()
	{
		
	}

	getEditorStyles()
	{
		let menuItemId = this.props.menuItemId;
		let formId = this.props.formId;
		let colId = this.props.colXml.id;
		return FormItemUtil.getControlStyles(menuItemId,formId,colId);
	}

	onBindStyleStore(formId,name)
	{
		if(formId == this.props.formId && (this.props.colXml.name == name || this.props.gridXml.name == name))
		{
			this.forceUpdate();
		}
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemEditorRender.js